import { NgModule } from '@angular/core';
import { AvailabilityDataAccessModule } from '@availability/data-access';
import { AvailabilityFeatureModule } from '@availability/feature';
import { CustomProductCmsComponents } from '@core/const';
import { CmsConfig, ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    AvailabilityDataAccessModule,
    AvailabilityFeatureModule,
    ConfigModule.withConfig(<CmsConfig>{
      featureModules: {
        availabilityShellModule: {
          module: () =>
            import('./sdvor-availability-shell-lazy.module').then((m) => m.SdvorAvailabilityShellLazyModule),
          cmsComponents: [CustomProductCmsComponents.SdCMSProductAvailabilityComponent],
        },
      },
    }),
  ],
})
export class SdvorAvailabilityShellModule {}
